// ** React Imports
import { Link } from "react-router-dom"

// ** Reactstrap Imports
import { Button } from "reactstrap"

// ** Styles
import "@styles/base/pages/page-misc.scss"

const Error = () => {
  return (
    <div className="misc-wrapper">
      <div className="misc-inner p-2 p-sm-3">
        <div className="w-100 text-center">
          <h2 className="mb-1">Page Not Found</h2>
          <p className="mb-2">Oops! The requested page was not found.</p>
          <Button tag={Link} to="/" color="primary" className="btn-sm-block mb-2">
            Back home
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Error
